
module Meevo.Plugins.ClientApp {

    import ICustomBranding = Meevo.Model.ICustomBranding;
    import StorageTypeEnum = Meevo.Model.StorageTypeEnum;
    import IStorageFile = Meevo.Model.IStorageFile;

    import ElementTypeEnum = Meevo.Model.ElementTypeEnum;
    import VerticalAlignmentEnum = Meevo.Model.VerticalAlignmentEnum;
    import HorizontalAlignmentEnum = Meevo.Model.HorizontalAlignmentEnum;
    import ShowThisPromotionUponLoginEnum = Meevo.Model.ShowThisPromotionUponLoginEnum;

    enum tabIdsEnum {
        customImage = 1,
        gradientColors = 2,
        templates = 3
    }

    interface ITab {
        displayName: string;
        tabId: tabIdsEnum
    }

    const MAX_ELEMENTS_PER_TYPE = 2;

    export class InAppPromotionsSection extends Meevo.Components.CommonClasses.CommonSectionBase {

        public securityKeyDelete: any;
        public selectedTab: ITab;
        public tabs: any;
        public selectAnElementLabel: string;
        public selectAFontLabel: string;
        public fonts: any;
        public newElement?: ElementTypeEnum;
        public element: Meevo.Model.InAppPromotionElement;
        public promotionListing: any;
        public customButtonsSet: any;
        public auditNoun: Meevo.Model.NounEnum;

        public minStartDate: Date;
        public scheduleStartDate: Date;
        public scheduleEndDate: Date;
        public selectedSlideIndex: number;
        public selectedSlideUrl: string;
        public inAppPromoSwiperId: number = 1;
        public promotionalTemplates: any;
        public selectedTemplate: any;
        public selectedCustomImage: any;

        constructor(sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.CommonClasses.ICommonDataService,
            protected $q: ng.IQService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            noun: Meevo.Model.NounEnum = null,
            identityService: Components.Common.IIdentityService = null,
            protected basedataService: Meevo.Components.BaseClasses.IDataService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected $translate: angular.translate.ITranslateService,
            sectionSecurityKey?: string,
            protected context?: Meevo.Plugins.ClientApp.ClientAppContext) {

            super(sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud, baseEndpoint, sectionEndpoint, loggingService, dataService, noun, identityService, sectionSecurityKey + Meevo.Components.Common.SecurityParts.KEY_PART_READ);
            this.auditNoun = Meevo.Model.NounEnum.ClientAppPromotion;
            this.securityKeyDelete = sectionSecurityKey + Meevo.Components.Common.SecurityParts.KEY_PART_DELETE;
            this.selectAnElementLabel = $translate.instant('LABEL_SELECT_ELEMENT');
            this.selectAFontLabel = $translate.instant('LABEL_SELECT_FONT_FAMILY');
            this.newElement = null;
            this.selectedTemplate = null;
            this.selectedCustomImage = null;
            this.setupStarterData();
            //this.getPromotionListing();
            this.context.setMode(Meevo.Model.MaintenanceFormState.Pending);
            this.mode = Model.MaintenanceFormState.Pending;
            var scope = this;
            this.customButtonsSet = [
                {
                    text: 'LABEL_SAVE',
                    clickHandler: () => {
                        if (!this.model.displayName || !this.model.scheduleStartDate) {
                            this.modalService.alert("MESSAGE_COMPLETE_ALL_FIELDS_THAT_REQUIRE_ATTENTION");//, 0, true);
                            return;
                        }

                        if (!this.validateStartDate(this.Model.scheduleStartDate)) {
                            this.modalService.alert("MESSAGE_FUTURE_START_DATE_NEEDED_FOR_PUSH_NOTIFICATION");
                            return;
                        }

                        this.basedataService.trackUsage(Meevo.Model.NounEnum.ClientAppPromotionTab, Model.VerbEnum.SaveButtonClicked, null, null);
                        scope.savePromotion();
                        this.slideSwiperToSelectedImage();
                        this.context.setMode(Meevo.Model.MaintenanceFormState.Readonly);
                        this.mode = Model.MaintenanceFormState.Readonly;
                    },
                    classNames: 'meevo-button',
                    disableRules: () => false,
                    visibilityRules: () => this.mode == Meevo.Model.MaintenanceFormState.Editing || this.mode == Meevo.Model.MaintenanceFormState.Adding,
                    securityRules: Meevo.Components.Common.SecurityKeys.INTEGRATION_CLIENTAPP_TAB_INAPPPROMOTIONS + Meevo.Components.Common.SecurityParts.KEY_PART_WRITE,
                    position: 'right'
                },
                {
                    text: 'LABEL_CANCEL',
                    clickHandler: () => {
                        this.basedataService.trackUsage(Meevo.Model.NounEnum.ClientAppPromotionTab, Model.VerbEnum.CancelButtonClicked, null, null);
                        this.reloadPromotionListing();
                        scope.context.cancel();
                        this.slideSwiperToSelectedImage();
                    },
                    classNames: 'meevo-button client-transaction-nav-button',
                    disableRules: () => false,
                    visibilityRules: () => this.mode == Meevo.Model.MaintenanceFormState.Readonly || this.mode == Meevo.Model.MaintenanceFormState.Adding,
                    securityRules: null,
                    position: 'right'
                },
                {
                    text: 'LABEL_EDIT',
                    clickHandler: () => {
                        this.basedataService.trackUsage(Meevo.Model.NounEnum.ClientAppPromotionTab, Model.VerbEnum.EditButtonClicked, null, null);
                        scope.context.edit();
                        scope.takeBackup();
                    },
                    classNames: 'meevo-button',
                    disableRules: () => false,
                    visibilityRules: () => this.mode == Meevo.Model.MaintenanceFormState.Readonly,
                    securityRules: Meevo.Components.Common.SecurityKeys.INTEGRATION_CLIENTAPP_TAB_INAPPPROMOTIONS + Meevo.Components.Common.SecurityParts.KEY_PART_WRITE,
                    position: 'right'
                },
                {
                    text: 'LABEL_CANCEL',
                    clickHandler: () => {
                        this.basedataService.trackUsage(Meevo.Model.NounEnum.ClientAppPromotionTab, Model.VerbEnum.CancelButtonClicked, null, null);
                        scope.model = scope["backup"];
                        scope.context.setMode(Model.MaintenanceFormState.Readonly);
                        scope.mode = Model.MaintenanceFormState.Readonly;
                        scope.context["showFooterAddNew"] = false;
                        this.slideSwiperToSelectedImage();
                    },
                    classNames: 'meevo-button',
                    disableRules: () => false,
                    visibilityRules: () => this.mode == Meevo.Model.MaintenanceFormState.Editing,
                    securityRules: Meevo.Components.Common.SecurityKeys.INTEGRATION_CLIENTAPP_TAB_INAPPPROMOTIONS + Meevo.Components.Common.SecurityParts.KEY_PART_WRITE,
                    position: 'right'
                },
                {
                    text: 'LABEL_COPY',
                    clickHandler: () => {
                        this.basedataService.trackUsage(Meevo.Model.NounEnum.ClientAppPromotionTab, Model.VerbEnum.CopyButtonClicked, null, null);
                        scope.context.edit();
                        scope.PrepareCopyModel();
                        scope.takeBackup();
                    },
                    classNames: 'meevo-button',
                    disableRules: () => false,
                    visibilityRules: () => this.mode == Meevo.Model.MaintenanceFormState.Readonly,
                    securityRules: Meevo.Components.Common.SecurityKeys.INTEGRATION_CLIENTAPP_TAB_INAPPPROMOTIONS + Meevo.Components.Common.SecurityParts.KEY_PART_WRITE,
                    position: 'left'
                },
                {
                    text: 'LABEL_ADD_NEW',
                    clickHandler: () => {
                        this.basedataService.trackUsage(Meevo.Model.NounEnum.ClientAppPromotionTab, Model.VerbEnum.AddNewButtonClicked, null, null);
                        this.setupDefaultModel();
                        this.selectedTab = this.tabs.templates;
                        scope.context.setMode(Model.MaintenanceFormState.Adding);
                        scope.mode = Model.MaintenanceFormState.Adding;
                        scope.takeBackup();
                    },
                    classNames: 'meevo-button client-transaction-nav-button',
                    disableRules: () => false,
                    visibilityRules: () => this.mode == Meevo.Model.MaintenanceFormState.Pending,
                    securityRules: Meevo.Components.Common.SecurityKeys.INTEGRATION_CLIENTAPP_TAB_INAPPPROMOTIONS + Meevo.Components.Common.SecurityParts.KEY_PART_WRITE,
                    position: 'right'
                },
            ];

            this.context.$scope.$watch(() => this.mode, (nv, ov) => {
                if (this.swiperInstance) {
                    if (nv == Meevo.Model.MaintenanceFormState.Adding || nv == Meevo.Model.MaintenanceFormState.Editing) {
                        this.swiperInstance.unlockSwipes();
                    }
                    else {
                        this.swiperInstance.lockSwipes();
                    }
                }
            });

        }

        public selectTab(tab: ITab): void {
            this.selectedTab = tab;
            this.model.backgroundType = tab.tabId - 1;

            if (this.model.backgroundImageObj != undefined && this.model.backgroundImageObj.meevoFile != null && this.model.backgroundImageObj.meevoFile['storageTypeEnum'] == StorageTypeEnum.ClientAppPromoBackground) {
                this.selectedCustomImage = this.model.backgroundImageObj;
            }

            if (this.selectedTab == this.tabs.customImage || this.selectedTab == this.tabs.templates) {
                this.model.backgroundImageObj = {};
                if (this.selectedTab == this.tabs.templates && this.selectedTemplate != null) {
                    this.model.backgroundImageObj = this.selectedTemplate;
                }
                else if (this.selectedTab == this.tabs.customImage && this.selectedCustomImage != null) {
                    this.model.backgroundImageObj = this.selectedCustomImage;
                }

            }
        }

        public setActiveTab(): number {
            return this.model.selectedBackgroundImageOption - 1;
        }

        public addNewElement() {
            this.element = {
                type: ElementTypeEnum.Text,
                displayText: "",
                textColor: "#000000",
                fontFamily: "",
                fontSize: 10,
                fontBold: false,
                fontItalic: false,
                fontUnderlined: false,
                textAlignment: HorizontalAlignmentEnum.Center,
                verticalAlignment: VerticalAlignmentEnum.Middle,
                backgroundColor: "#000000",
                actionUrl: ""
            };
            this.element.type = this.newElement.valueOf();

            if (this.getElementAmount(this.element.type) >= MAX_ELEMENTS_PER_TYPE) {
                this.newElement = null;
                this.modalService.alert("LABEL_MAX_AMOUNT_OF_ELEMENTS");
                return;
            }

            if (this.model.elements == null)
                this.model.elements = [];
            this.model.elements.push(this.element);

            this.newElement = null;
        }

        public removePromotion(index: number) {
            if (index > -1) {
                this.model.elements.splice(index, 1);
            }
        }

        public getElementNumber(index: number): number {
            var returnVal = 1;

            for (var i = 0; i < this.model.elements.length; i++) {
                if (i != index && this.model.elements[i].type == this.model.elements[index].type && i > index) {
                    returnVal++;
                }
            }

            return returnVal;
        }

        public getElementAmount(type: number): number {
            var returnVal = 0;

            if (this.model.elements != null) {
                for (var i = 0; i < this.model.elements.length; i++) {
                    if (this.model.elements[i].type == type) {
                        returnVal++;
                    }
                }
            }

            return returnVal;
        }

        setupDefaultModel() {
            this.model = {
                id: null,
                objectStateEnum: Meevo.Model.ObjectStateEnum.Inactive,
                backgroundStartColor: "#000000",
                backgroundEndColor: "#000000",
                backgroundType: 2,
                scheduleShowOption: ShowThisPromotionUponLoginEnum.OnlyOnce,
                scheduleStartDate: new Date(),
                scheduleEndDate: null
            } as Meevo.Model.InAppPromotion;

            this.minStartDate = null;
            this.scheduleStartDate = new Date(this.model.scheduleStartDate);
            this.scheduleEndDate = null;
        }

        public setupStarterData() {
            this.reloadPromotionListing();
            if (this.model == null || this.model == "") {
                this.setupDefaultModel();
            }
            this.element = {
                type: ElementTypeEnum.Text,
                displayText: "",
                textColor: "#000000",
                fontFamily: "",
                fontSize: 10,
                fontBold: false,
                fontItalic: false,
                fontUnderlined: false,
                textAlignment: HorizontalAlignmentEnum.Left,
                verticalAlignment: VerticalAlignmentEnum.Top,
                backgroundColor: "#000000",
                actionUrl: ""
            } as Meevo.Model.InAppPromotionElement;
            this.tabs = {
                customImage: {
                    displayName: this.$translate.instant('LABEL_CUSTOM_IMAGE'),
                    tabId: tabIdsEnum.customImage
                },
                gradientColors: {
                    displayName: this.$translate.instant('LABEL_GRADIENT_COLORS'),
                    tabId: tabIdsEnum.gradientColors
                },
                templates: {
                    displayName: this.$translate.instant('LABEL_TEMPLATE'),
                    tabId: tabIdsEnum.templates
                }
            };
            this.selectTabBasedOnModel();
            this.fonts = [
                { value: 'Helvetica, Arial, Tahoma', label: 'Helvetica, Arial, Tahoma' },
                { value: 'Times New Roman, Georgia', label: 'Times New Roman, Georgia' },
                { value: 'Courier New, Monaco', label: 'Courier New, Monaco' },
                { value: 'Impact, Charcoal, sans-serif', label: 'Impact, Charcoal, sans- serif' },
                { value: 'Century Gothic, sans-serif', label: 'Century Gothic, sans-serif' },
                { value: 'Comic Sans MS, cursive, sans-serif', label: 'Comic Sans MS, cursive, sans-serif' }
            ];
        }


        public editPromotion(id: Guid) {
            var scope = this;
            return this.dataService.customMethodData("api/ClientApp/Promotion?Id=" + id, "GET", null).then((data) => {
                if (data.data) {
                    this.model = data.data;
                    this.selectTabBasedOnModel();
                    if (this.selectedTab == this.tabs.templates) {
                        this.selectedTemplate = this.model.backgroundImageObj;
                    }
                    else if (this.selectedTab == this.tabs.customImage) {
                        this.selectedCustomImage = this.model.backgroundImageObj;
                    }
                    scope.context.setMode(Model.MaintenanceFormState.Readonly);
                    scope.mode = Model.MaintenanceFormState.Readonly;

                    if (this.model.scheduleEndDate.getFullYear() == 9999) { // max date year
                        this.model.scheduleEndDate = null;
                        this.scheduleEndDate = null;
                    }
                    else {
                        this.scheduleEndDate = new Date(this.model.scheduleEndDate);
                    }
                    if (this.model.performPushNotification) {
                        // set minimum start date to tomorrow if push notification is requested
                        this.minStartDate = moment().startOf("day").add(1, "day").toDate();
                    }
                    else {
                        this.minStartDate = null;
                    }
                    this.scheduleStartDate = new Date(this.model.scheduleStartDate);

                    return this.loadImagesFromStorage();
                }
            });

        }

        public savePromotion() {
            this.busyService.start();
            return this.saveImages().then(() => {
                return this.dataService.customMethodData("api/ClientApp/Promotion", "POST", this.model).then((data) => {
                    if (data.data) {
                        this.model = data.data;
                        this.selectTabBasedOnModel();
                        if (this.model.scheduleEndDate == new Date(9999, 12, 31))
                            this.model.scheduleEndDate = null;
                        return this.loadImagesFromStorage();
                    }
                }).finally(() => {
                    this.busyService.stop();
                });
            });
        }

        selectTabBasedOnModel() {
            if (this.model.backgroundType == 0) {
                this.selectedTab = this.tabs.customImage;
            }
            else if (this.model.backgroundType == 1) {
                this.selectedTab = this.tabs.gradientColors;
            }
            else if (this.model.backgroundType == 2) {
                this.selectedTab = this.tabs.templates;
                this.fetchTemplate()
                    .then(() => {
                        this.slideSwiperToSelectedImage();
                    });
            }
        }

        slideSwiperToSelectedImage() {
            if (this.model && this.model.backgroundType == 2 && this.swiperInstance && this.promotionalTemplates) {
                // save these for later
                let backupSwiperLockNext = this.swiperInstance.params.allowSwipeToNext;
                let backupSwiperLockPrev = this.swiperInstance.params.allowSwipeToPrev;

                this.swiperInstance.unlockSwipes();

                // find index
                let slideIndex = _.findIndex(this.promotionalTemplates, (tmpl: any) => tmpl.fileGuid == this.model.backgroundImage);
                if (slideIndex >= 0) {
                    // select item
                    this.swiperInstance.slideTo(slideIndex, 0, false, true);
                }

                // return previous values, whatever they were
                this.swiperInstance.params.allowSwipeToNext = backupSwiperLockNext;
                this.swiperInstance.params.allowSwipeToPrev = backupSwiperLockPrev;
            }
        }

        public getGradientBackgroundColorAndPreviewHeight(): string  {

            var previewStyle = "";

            var height = this.getAllElementHeight(null);

            previewStyle += "height: 65vh; ";

            previewStyle += "position:relative; ";

            if (this.selectedTab != null && this.selectedTab.tabId == 2) {
                previewStyle += "background: linear-gradient(" + this.model.backgroundStartColor + ", " + this.model.backgroundEndColor + "); ";
            }
            else {
                let url = this.context.bindImageObj('backgroundImageObj', 'assets/images/photo_not_available.svg');
                previewStyle += "background-image:url('" + url + "');background-repeat:no-repeat;background-position:center;";
            }

            if (this.model.backgroundUrl != null && this.model.backgroundUrl != "" && !this.hasButtonElement()) {
                previewStyle += "cursor: pointer;";
            }

            return previewStyle;
        }

        public getAllElementHeight(excludeType?: ElementTypeEnum): number {
            var height = 0;
            if (this.model && this.model.elements) {
                for (var i = 0; i < this.model.elements.length; i++) {
                    if (this.model.elements[i].type == ElementTypeEnum.Image && (excludeType == null || excludeType != ElementTypeEnum.Image) && document.getElementById('previewImage' + i) != null) {
                        height += document.getElementById('previewImage' + i).offsetHeight;
                    }
                    else if (this.model.elements[i].type == ElementTypeEnum.Button && (excludeType == null || excludeType != ElementTypeEnum.Button) && $('#previewButton' + i) != null) {
                        height += $('#previewButton' + i).outerHeight(true); //document.getElementById('previewButton' + i).offsetHeight;
                    }
                    else if (this.model.elements[i].type == ElementTypeEnum.Text && (excludeType == null || excludeType != ElementTypeEnum.Text) && $('#previewText' + i) != null) {
                        height += $('#previewText' + i).outerHeight(true);//document.getElementById('previewText' + i).offsetHeight;
                    }
                }
            }
            return height;
        }

        public getImageElementStyle(element): string {
            var previewStyle = "height:" + this.getImageHeight() + "px;";

            previewStyle += "width:80%;text-align:center;margin:auto;";

            return previewStyle;
        }

        public getImageElementStyleHeight(element): string {
            var previewStyle = "height:" + this.getImageHeight() + "px;text-align: center;";
            return previewStyle;
        }


        public getImageHeight(): number{
            var previewContainerHeight = document.getElementById('previewContainer').offsetHeight;
            var height = previewContainerHeight;
            var amountOfImages = 0;

            // TODO: DETERMINE HEIGTH BASED ON IMAGE SIZE IF IMAGE ELEMENTS ARE INCLUDED
            for (var i = 0; i < this.model.elements.length; i++) {
                if (this.model.elements[i].type == ElementTypeEnum.Image) {
                    amountOfImages++;
                }
            }

            if (amountOfImages == 0)
                return 0;

            var nonImageHeight = this.getAllElementHeight(ElementTypeEnum.Image);

            height = (previewContainerHeight - nonImageHeight) / amountOfImages;

            return height;
        }

        public getElementPreviewStyle(element): string {
            var previewStyle = "";

            if (element.fontSize != 0) {
                previewStyle += 'font-size: ' + element.fontSize + 'px; ';
            }

            if (element.textColor != '') {
                previewStyle += 'color: ' + element.textColor + '; ';
            }

            if (element.textAlignment == HorizontalAlignmentEnum.Left) {
                previewStyle += 'text-align: left; ';
            }
            else if (element.textAlignment == HorizontalAlignmentEnum.Center) {
                previewStyle += 'text-align: center; ';
            }
            else if (element.textAlignment == HorizontalAlignmentEnum.Right) {
                previewStyle += 'text-align: right; ';
            }

            if (element.type == ElementTypeEnum.Text) {
                previewStyle += 'white-space: pre; ';
            }

            if (element.type == ElementTypeEnum.Text || element.type == ElementTypeEnum.Button) {
                if (element.verticalAlignment == VerticalAlignmentEnum.Top) {
                    previewStyle += 'vertical-align: top; ';
                }
                else if (element.verticalAlignment == VerticalAlignmentEnum.Middle) {
                    previewStyle += 'vertical-align: -webkit-baseline-middle; ';
                }
                else if (element.verticalAlignment == VerticalAlignmentEnum.Bottom) {
                    previewStyle += 'vertical-align: bottom; ';
                }
            }

            if (element.type == ElementTypeEnum.Button && element.backgroundColor != '') {
                previewStyle += 'background-color: ' + element.backgroundColor + '; ';
            }

            if (element.fontSize != 0) {
                var size = element.fontSize + 24;
                previewStyle += 'height: ' + size + 'px; ';
            }
            else {
                previewStyle += 'height: 24px; ';
            }

            if (element.fontFamily) {
                previewStyle += 'font-family: ' + element.fontFamily + '; ';
            }

            if (element.fontBold) {
                previewStyle += 'font-weight: bold; ';
            }

            if (element.fontItalic) {
                previewStyle += 'font-style: italic; ';
            }

            if (element.fontUnderlined) {
                previewStyle += 'text-decoration: underline; ';
            }

            return previewStyle;
        }

        public getElementStyle(element: Meevo.Model.InAppPromotionElement): object{
            var style = {};

            var size = element.fontSize + 24;

            if (element.textColor != '') {
                style['color'] = element.textColor;
            }

            if (element.type == ElementTypeEnum.Text) {
                style['white-space'] = 'pre-wrap';
                style['overflow-wrap'] = 'break-word';
            }

            if (element.type == ElementTypeEnum.Button) {
                style['border-radius'] = Math.floor(size / 2) + 'px';
                style['padding'] = '3px 27px';

                if (element.backgroundColor != '') {
                    style['background-color'] = element.backgroundColor;
                }
            }

            if (element.type == ElementTypeEnum.Image) {
                style['height'] = '100%';
            }
            else {
                style['height'] = size + 'px';
            }

            if (element.fontSize != 0) {
                style['font-size'] = element.fontSize + 'px';
            }

            if (element.fontFamily) {
                style['font-family'] = element.fontFamily;
            }

            if (element.fontBold) {
                style['font-weight'] = 'bold';
            }

            if (element.fontItalic) {
                style['font-style'] = 'italic';
            }

            if (element.fontUnderlined) {
                style['text-decoration'] = 'underline';
            }

            return style;
        }

        public getElementContainerStyle(element: Meevo.Model.InAppPromotionElement): object {
            var style = {
                'text-align': 'center',
                'vertical-align': 'middle'
            };

            if (element.textAlignment == HorizontalAlignmentEnum.Left) {
                style['text-align'] = 'left';
            }
            else if (element.textAlignment == HorizontalAlignmentEnum.Right) {
                style['text-align'] = 'right';
            }

            if (element.type == ElementTypeEnum.Text) {
                style['white-space'] = 'pre';
            }

            if (element.verticalAlignment == VerticalAlignmentEnum.Top) {
                style['vertical-align'] = 'top';
            }
            else if (element.verticalAlignment == VerticalAlignmentEnum.Bottom) {
                style['vertical-align'] = 'bottom';
            }

            return style;
        }

        prevBackgroundImage: any = null;
        backgroundImage: any = null;
        backgroundImageStyle: object = { "position": "relative" };
        public getBackgroundImagePreviewStyle(): object {
            if (this.backgroundImage == null) {
                this.backgroundImage = new Image();
            }
            let url = this.context.searchFile(this.model.backgroundImageObj, "Source", null);
            if (this.prevBackgroundImage == null && url != null) {
                var section = this;
                this.backgroundImage.onload = function () {
                    let previewElem = document.getElementById("previewImageContainer");
                    let previewRatio = previewElem.clientWidth / previewElem.clientHeight;
                    let imgElem: HTMLImageElement = (this as HTMLImageElement);
                    let imageRatio = imgElem.width / imgElem.height;
                    // compare image's ratio with preview ratio
                    //if (imageRatio > previewRatio) {
                        section.backgroundImageStyle["width"] = "auto";
                        section.backgroundImageStyle["height"] = "100%";
                        section.backgroundImageStyle["left"] = -((previewElem.clientHeight / imgElem.height * imgElem.width) - previewElem.clientWidth) / 2;
                        section.backgroundImageStyle["top"] = "0px";
                    
                    //else {
                    //    section.backgroundImageStyle["width"] = "100%";
                    //    section.backgroundImageStyle["height"] = "auto";
                    //    section.backgroundImageStyle["left"] = "0px";
                    //    section.backgroundImageStyle["top"] = -((previewElem.clientWidth / imgElem.width * imgElem.height) - previewElem.clientHeight) / 2;
                    //}
                }
                this.backgroundImage.src = url;
            } else if (this.model.backgroundType == this.tabs.templates.tabId - 1) {
                this.backgroundImageStyle = {
                    "position": "relative",
                    "height": "100%",
                    "width": "100%"
                };
            }
            else {
                this.backgroundImageStyle = { "position": "relative" };
            }
            return this.backgroundImageStyle;
        }

        public getElementPreviewStyleHeightAndAlignment(element, index): string {
            var previewStyle = "";

            if (element.type == ElementTypeEnum.Button) {
                if (element.fontSize != 0) {
                    var size = element.fontSize + 24;
                    previewStyle += 'height: ' + size + 'px; ';
                }
                else {
                    previewStyle += 'height: 24px; ';
                }
            }

            if (element.textAlignment == HorizontalAlignmentEnum.Left) {
                previewStyle += 'text-align: left; ';
            }
            else if (element.textAlignment == HorizontalAlignmentEnum.Center) {
                previewStyle += 'text-align: center; ';
            }
            else if (element.textAlignment == HorizontalAlignmentEnum.Right) {
                previewStyle += 'text-align: right; ';
            }

            if (element.type == ElementTypeEnum.Text || element.type == ElementTypeEnum.Button) {
                
                var elementHeight = 0;
                if (element.type == ElementTypeEnum.Text && document.getElementById('previewText' + index) != null)
                    elementHeight = document.getElementById('previewText' + index).offsetHeight;
                else if (element.type == ElementTypeEnum.Button && document.getElementById('previewButton' + index) != null)
                    elementHeight = document.getElementById('previewButton' + index).offsetHeight;

                if (element.verticalAlignment == VerticalAlignmentEnum.Top) {
                    previewStyle += 'margin-bottom: ' + ((element.fontSize / 4) + 3) + 'px; ';
                }
                else if (element.verticalAlignment == VerticalAlignmentEnum.Middle) {
                    previewStyle += 'margin-top: ' + ((element.fontSize / 4) + 3) + 'px; ';
                    previewStyle += 'margin-bottom: ' + ((element.fontSize / 4) + 3) + 'px; ';
                }
                else if (element.verticalAlignment == VerticalAlignmentEnum.Bottom) {
                    previewStyle += 'margin-top: ' + ((element.fontSize / 4) + 3) + 'px; ';
                }
            }

            return previewStyle;
        }

        public openNewWindow(element) {
            if (element.actionUrl == null || element.actionUrl == "")
                return;

            if (element.actionUrl.includes("https://") || element.actionUrl.includes("http://"))
                window.open(element.actionUrl);
            else 
                window.open("https://" + element.actionUrl);
        }

        public openBackgroundWindow() {
            if (this.model == null || this.model.backgroundUrl == "" || this.hasButtonElement())
                return;

            if (this.model.backgroundUrl.includes("https://") || this.model.backgroundUrl.includes("http://"))
                window.open(this.model.backgroundUrl);
            else
                window.open("https://" + this.model.backgroundUrl);
        }

        public hasButtonElement(): boolean {
            if (this.model && this.model.elements) {
                for (var i = 0; i < this.model.elements.length; i++) {
                    if (this.model.elements[i].type == ElementTypeEnum.Button) {
                        return true;
                    }
                }
            }
            return false;
        }

        reOrder = (index1: number, index2: number, array: any) => {
            array[index1].sortOrder = index2;
            array[index2].sortOrder = index1;
            if (array[index1] && array[index2]) {
                var temp = array[index2];
                array[index2] = array[index1];
                array[index1] = temp;
            }
        }

        public saveImages(): ng.IPromise<void> {
            this.busyService.start();

            var promises: ng.IPromise<any>[] = [];
            if (this.model.backgroundType !== 1) {  // backgrounType = 1 Gradient
                promises.push(this.model.backgroundImageObj ? this.saveImageToStorage(this.model.backgroundImageObj) : this.$q.resolve(null));
            }

            var imageElements: Meevo.Model.InAppPromotionElement[] = _.filter(this.model.elements, (item: Meevo.Model.InAppPromotionElement) => { return item.type === ElementTypeEnum.Image; });
            promises.push(..._.map(imageElements, (item: Meevo.Model.InAppPromotionElement) => item.imageObj ? this.saveImageToStorage(item.imageObj) : this.$q.resolve(null)));

            return this.$q.all(promises).then((responses: Array<IStorageFile | any>) => {
                if (this.model && this.model.backgroundImageObj) {
                    this.model.backgroundImage = this.model.backgroundImageObj.fileGuid;
                }
                if (responses.length == imageElements.length + 1) {
                    imageElements.forEach((item, ndx, arr) => {
                        if (responses[ndx + 1] && responses[ndx + 1].data && responses[ndx + 1].data.meevoFile) {
                            item.image = item.imageObj.fileGuid;
                        }
                    });
                }
                
                if (responses.length == imageElements.length) { // if backgrounType = 1 Gradient
                    imageElements.forEach((item, ndx, arr) => {
                        if (responses[ndx] && responses[ndx].data && responses[ndx].data.meevoFile) {
                            item.image = item.imageObj.fileGuid;
                        }
                    });
                }
            }).catch(error => {
                this.loggingService.trace(error.statusText);
            }).finally(() => {
                this.busyService.stop();
            });
        }

        protected isImagesLoading: boolean = false;
        loadImagesFromStorage(): ng.IPromise<void> {
            if (this.isImagesLoading) { 
                return;
            }
            this.isImagesLoading = true;
            this.busyService.start();

            var promises: ng.IPromise<any>[] = [];
            if (this.model.backgroundType !== 1) {  // backgrounType = 1 Gradient
                let storageEnum = this.model.backgroundType == 2 ? StorageTypeEnum.SystemFile : StorageTypeEnum.ClientAppPromoBackground;
                promises.push(this.getImageUrl(storageEnum, this.model.backgroundImage));
            }

            var imageElements: Meevo.Model.InAppPromotionElement[] = _.filter(this.model.elements, (item: Meevo.Model.InAppPromotionElement) => { return item.type === ElementTypeEnum.Image; });
            promises.push(..._.map(imageElements, (item: Meevo.Model.InAppPromotionElement) => this.getImageUrl(StorageTypeEnum.ClientAppPromoImage, item.image)));

            return this.$q.all(promises).then((responses) => {
                this.model.backgroundImageObj = responses[0].data || {};
                if (responses.length == imageElements.length + 1) {
                    imageElements.forEach((item, ndx, arr) => {
                        item.imageObj = responses[ndx + 1].data || {};
                    });
                }
                if (responses.length == imageElements.length) {  // if backgrounType = 1 Gradient
                    imageElements.forEach((item, ndx, arr) => {
                        item.imageObj = responses[ndx].data || {};
                    });
                } 
            }).finally(() => {
                this.busyService.stop();
                this.isImagesLoading = false;
            });
        }

        public getImageUrl(storageTypeEnum: StorageTypeEnum, fileGuid: Guid | string): angular.IPromise<any> {
            if (!fileGuid) {
                return this.$q.resolve({});
            }

            return this.dataService.customMethodData(`/api/storage/customBrandingImage/${storageTypeEnum}/${fileGuid}`, 'GET', null);
        }

        /**
         * Save image to storage
         * @param {IStorageFile} file
         * @returns {angular.IPromise}
         */
        public saveImageToStorage(file: IStorageFile = {}): angular.IPromise<any> {
            if (!Object.keys(file).length) {
                return this.$q.resolve({});
            }

            return this.dataService.customMethodData('/api/storage/customBrandingImage', 'POST', {
                customBrandingImageResource: _.extend(file, { resourceType: file.meevoFile['storageTypeEnum'], contentType: file.contentType })
            });
        }

        public getStatusString(objectStateEnum): string {
            if (objectStateEnum == Meevo.Model.ObjectStateEnum.Active) {
                return this.$translate.instant('LABEL_ACTIVE');
            }
            else {
                return this.$translate.instant('LABEL_INACTIVE');
            }
        }

        get isAdding(): boolean {
            return this.mode === Meevo.Model.MaintenanceFormState.Adding;
        }

        public reloadPromotionListing() {
            var criteria = {
                criteria: {
                    businessType: null,
                    coBusinessTypeId: null,
                    coFilterByLocationId: null,
                    coSearchResultFilter: 0,
                    coSearchType: 0,
                    includeActive: true,
                    includeDeleted: false,
                    includeInactive: false,
                    location: null,
                    maintenanceMode: true,
                },
                itemsPerPage: 25,
                pageNumber: 0,
                sortBy: null,
                sortDirection: 0
            };

            this.selectedCustomImage = null;
            this.selectedTemplate = null;
            this.selectedSlideIndex = null;
            this.selectedSlideUrl = null;

            this.promotionListing = new Meevo.Components.BaseClasses.PagedResults(this.basedataService, "ClientApp/Promotion");
            this.promotionListing.initSearch(criteria, null, criteria);
        }

        PrepareCopyModel() {
            this.model.id = null;
            this.model.entityVersion = 0;
            if (this.model && this.model.elements) {
                for (var i = 0; i < this.model.elements.length; i++) {
                    this.model.elements[i].id = null;
                    this.model.elements[i].entityVersion = 0;
                }
            }
        }

        handlePushNotificationChange() {
            if (this.Model.performPushNotification) {
                // set minimum start date to tomorrow if push notification is requested
                this.minStartDate = moment().startOf("day").add(1, "day").toDate();
            }
            else {
                this.minStartDate = null;
            }
            $("#scheduleStartDate > md-datepicker").toggleClass("ng-valid", this.validateStartDate(this.Model.scheduleStartDate));
            $("#scheduleStartDate > md-datepicker").toggleClass("ng-invalid", !this.validateStartDate(this.Model.scheduleStartDate));
            $("#scheduleStartDate > md-datepicker").scope().$digest();
        }

        updateStartDate() {
            this.Model.scheduleStartDate = this.scheduleStartDate;
        }

        updateEndDate() {
            this.Model.scheduleEndDate = this.scheduleEndDate;
        }

        get Model(): Meevo.Model.InAppPromotion {
            if (this.model) {
                return this.model as Meevo.Model.InAppPromotion;
            }
            return null;
        }

        validateStartDate(date: Date): boolean {
            return !(this.Model.performPushNotification) || (angular.isDate(date) && (moment(date).isSame(this.minStartDate) || moment(date).isAfter(this.minStartDate)));
        }

        public fetchTemplate(): ng.IPromise<any> {
            if (!this.promotionalTemplates) {
                return this.dataService.customMethodData("api/ClientApp/Promotion/Template/List", 'GET', null).then((response) => {
                    if (response && response.data) {
                        this.promotionalTemplates = response.data;
                    }
                });
            }
            else {
                return this.$q.resolve();
            }
        }

        public selectTemplate(): void {           
            let swiperInstance = $("#swiper-" + this.inAppPromoSwiperId)
            this.selectedSlideIndex = swiperInstance[0]["swiper"].activeIndex;
            this.selectedSlideUrl = this.promotionalTemplates[this.selectedSlideIndex].meevoFile.files[0].fileUrl
         
            if (!this.model.backgroundImageObj) {
                this.model.backgroundImageObj = {};
            }
            this.model.backgroundImageObj.meevoFile = this.promotionalTemplates[this.selectedSlideIndex].meevoFile;
            this.model.backgroundImageObj.fileGuid = this.model.backgroundImage = this.promotionalTemplates[this.selectedSlideIndex].fileGuid;
            this.model.backgroundImageObj.contentType = this.promotionalTemplates[this.selectedSlideIndex].contentType;
            this.model.backgroundImageObj.isStorageUpdated = this.promotionalTemplates[this.selectedSlideIndex].isStorageUpdated;
            this.selectedTemplate = this.model.backgroundImageObj;
        }

        public swiperInstance = null;
        initializeSwiper = (swiperObj) => {
            this.swiperInstance = swiperObj;
            if (this.mode == Meevo.Model.MaintenanceFormState.Adding || this.mode == Meevo.Model.MaintenanceFormState.Editing) {
                this.swiperInstance.unlockSwipes();
            }
            else {
                this.swiperInstance.lockSwipes();
            }
            this.slideSwiperToSelectedImage();
        };
    }
}
